<div class="position-popup">
  <div class="modal-header">
    <h5 class="modal-title" id="permissionModalLabel">Positions</h5>
    <div class="d-flex justify-content-end ms-auto">
      <button type="button" class="btn col-auto me-2 btn-secondary" (click)="dismissPopup()"><i class="fa fa-times"></i> Cancel</button>
      <button type="button" class="btn col-auto btn-primary" (click)="savePosition()"> <i class="fa fa-save"></i> Save</button>
    </div>

  </div>
  <div class="modal-body">
    <app-position-edit #positionEdit [position]="position" (positionSaved)="positionSaved($event)"></app-position-edit>
  </div>
</div>
